/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { createSelector, OutputSelector } from 'reselect';

import { IRootReducer } from '../../reducers/rootReducer';
import {
    IWizardExpensesDetailHierarchyLevel,
    IWizardExpensesDetailValidation,
} from './types/wizardExpensesDetailTypes';
import { initWizardExpensesDetailState } from './wizardExpensesDetailConstant';
import { IWizardExpensesDetailReducer } from './wizardExpensesDetailReducer';

export const makeSelectWizardExpensesDetailState = (state: IRootReducer): IWizardExpensesDetailReducer =>
    state.wizardExpensesDetail || initWizardExpensesDetailState;

export const makeSelectWizardExpensesDetailDate = ():
    OutputSelector<IRootReducer, string, (state: IWizardExpensesDetailReducer) => string> =>
    createSelector(makeSelectWizardExpensesDetailState, state => state.date);

export const makeSelectWizardExpensesDetailFormatsAvailable = ():
    OutputSelector<IRootReducer, string[], (state: IWizardExpensesDetailReducer) => string[]> =>
    createSelector(makeSelectWizardExpensesDetailState, state => state.formatsAvailable);

export const makeSelectWizardExpensesDetailFormatsAvailableChosen = ():
    OutputSelector<IRootReducer, string, (state: IWizardExpensesDetailReducer) => string> =>
    createSelector(makeSelectWizardExpensesDetailState, state => state.formatsAvailableChosen);

export const makeSelectWizardExpensesDetailHierarchyLevels = ():
    OutputSelector<IRootReducer, IWizardExpensesDetailHierarchyLevel[],
        (state: IWizardExpensesDetailReducer) => IWizardExpensesDetailHierarchyLevel[]> =>
    createSelector(makeSelectWizardExpensesDetailState, state => state.hierarchyLevels);

export const makeSelectWizardExpensesDetailHierarchyLevelsChosen = ():
    OutputSelector<IRootReducer, IWizardExpensesDetailHierarchyLevel,
        (state: IWizardExpensesDetailReducer) => IWizardExpensesDetailHierarchyLevel> =>
    createSelector(makeSelectWizardExpensesDetailState, state => state.hierarchyLevelsChosen);

export const makeSelectWizardExpensesDetailValidation = ():
    OutputSelector<IRootReducer, IWizardExpensesDetailValidation,
        (state: IWizardExpensesDetailReducer) => IWizardExpensesDetailValidation> =>
    createSelector(makeSelectWizardExpensesDetailState, state => state.validation);

export const makeSelectWizardExpensesDetailMaxDate = ():
    OutputSelector<IRootReducer, string,
        (state: IWizardExpensesDetailReducer) => string> =>
    createSelector(makeSelectWizardExpensesDetailState, state => state.maxDate);
